/**
 * Convert 24-hour HH:MM into 12-hour American format ("1:00 PM", "10:00 AM").
 * Returns the input unchanged if it doesn't match the expected pattern.
 */
export function formatTime12h(hhmm) {
  if (typeof hhmm !== "string") return hhmm;
  const m = hhmm.match(/^(\d{1,2}):(\d{2})$/);
  if (!m) return hhmm;
  let h = parseInt(m[1], 10);
  const mm = m[2];
  const meridiem = h >= 12 ? "PM" : "AM";
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${mm} ${meridiem}`;
}
